import styled from 'styled-components';
import { colors } from '@root/src/app/layout/design';
import { LinkParagraph, Paragraph } from '@designSystem/typings';
import { Header } from '@designSystem/typings';

export const StyledDetailsPanel = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`;

export const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 49%;
  height: fit-content;
  border-radius: 10px;
  padding: 40px;
  background-color: ${colors.white};
`;

export const StyledParagraph = styled(Paragraph)`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const StyledLinkParagraph = styled(LinkParagraph)`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  * {
    width: 50%;
  }
`;

export const WrapHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const StyledHeader = styled(Header)`
  line-height: 44px;
`;
